export class SearchResult {
    results: Results;
    suggestions: [string];

    constructor(json: Object) {
        return Object.assign(this, json);
    }
}

export class Results {
    count: number;
    segments: Segments;
}

export class Segments {
    pages: [Page];
    users: [User];
}

export class Page {
    title: string;
    description: string;
    score: number;
    link: string;
    image: string;
}

export class User {
    name: string;
    score: number;
    link: string;
    image: string;
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/search/search-result.ts